import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { makeStyles } from '@rentacenter/racstrap';
import { appConfig } from '../../config/app-config';
import { MicroFrontend } from './MicroFrontEnd';

export const testId = 'dailyActivityPlannerTestId';
const useStyles = makeStyles(() => ({
  microAppContainer: {
    marginTop: '3rem',
  },
}));

export const DailyActivityPlanner = ({ history }: RouteComponentProps) => {
  const classes = useStyles();
  return (
    <div className={classes.microAppContainer} data-testid={testId}>
      <MicroFrontend
        config={appConfig.microfrontends.dailyActivityPlanner}
        history={history}
      />
    </div>
  );
};
